import React from 'react';
import './product-financing.scss';
import ProductFinancing from 'modules/product/views/components/product-financing/product-financing';
import ProductSectionBox from 'modules/product/views/components/product-section-box';

interface ProductFinancingSectionProps {
    productPrice: number;
    isMobile: boolean;
}

const ProductFinancingSection: React.FC<ProductFinancingSectionProps> = ({
    productPrice,
    isMobile
}) => {
    return (
        <section id="financing" className="tab-section" data-section="financing">
            <ProductSectionBox headerText="Finansowanie" padding="lg">
                <ProductFinancing
                    productPrice={productPrice}
                    isMobile={isMobile}
                />
            </ProductSectionBox>
        </section>
    );
};

export default ProductFinancingSection;
